<template>
  <div class="tsBg"  @click="btnClick(false)">
    <div class="tsContent"  @click.stop>
      <h3>报名须知</h3>
        <ul>
          <li>报名信息必须真实有效，且满足近3年安全驾驶无事故；</li>
          <li>报名人员年龄需满足23-55周岁，身体健康；</li>
          <li>确认自愿使用平台信息服务；</li>
          <li>确认有以下证件：身份证、驾驶证；</li>
          <li>根据城市不同，确认同意在成功签约后从信息费账户扣缴报名注册费；</li>
          <li>当终止提供信息服务时，处理周期为90天；</li>
        </ul>
    </div>
    <!-- <img
        class="closeBtn"
        src="../../../assets/ts_close.png"
        alt="关闭"
        @click="btnClick(false)"
      /> -->
  </div>
</template>
<script>
export default {
  name: 'rules',
  methods: {
    btnClick (e) {
      this.$emit('hide')
    }
  }
}
</script>
<style lang="scss" scoped>
.tsBg {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba($color: #000000, $alpha: 0.6);
  z-index: 1;
  text-align: center;

  .tsContent {
    margin: 0 auto;
    margin-top: 3rem;
    width: 5.6rem;
    height: 4.52rem;
    padding: 0.2rem 0.4rem;
    background: #FFFFFF;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.20);
    border-radius: 0.12rem;
    font-size: .24rem;
    color: #19191A;
    h3 {
      font-weight: bold;
      margin: .36rem auto;
    }

    ul {
      text-align: left;
      list-style-type: decimal;
      margin-left: .35rem;
      line-height: .36rem;
    }
  }

  .closeBtn {
    width: 0.6rem;
    height: 0.6rem;
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/sign-up/components/rules.vue